import { Theme } from "@mui/material/styles";
import { detectHmo } from "utils/hmoDetection";
import { HMO } from "constants/hmo";

interface Styles {
  [key: string]: any;
}

const isLeumit = detectHmo() === HMO.LEUMIT;
export const styles = (theme: Theme): Styles => ({
  container: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    height: "100%",
  },
  bodyContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    alignItems: "flex-start",
    overflow: "auto",
  },
  warningTitle: {
    fontWeight: theme.typography.fontWeightMedium,
    marginBottom: theme.spacing.spacing4,
  },
  detailsTitle: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  youTubeContainer: {
    display: "flex",
    width: theme.width.full,
    justifyContent: "center",
  },
  attentionIconImage: {
    '& path': {
      ...(isLeumit && {
        fill: theme.palette.extraColors?.alert,
      }),
    },
  },
  attentionContainer: {
    display: "flex",
    alignItems: "center",
    width: theme.width.full,
    minHeight: 96,
    padding: theme.spacing.spacing4,
    marginTop: theme.spacing.spacing10,
    marginBottom: theme.spacing.spacing10,
    background: (theme.palette.background as any).secondary,
    borderRadius: theme.borders.borderRadius.xl,
  },
  detailsContainer: {
    display: "flex",
    flexDirection: "column",
    // justifyContent: "center",
    margin: `0 ${theme.spacing.spacing3}`,
  },
  attentionTitle: {
    display: "flex",
    flexDirection: "column",
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.size.md,
    lineHeight: "23px",
  },
  attentionDescription: {
    fontSize: theme.typography.size.xs,
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: "18px",
  },
  iconBackground: {
    position: "relative",
    height: 64,
    width: theme.width.width32,
    margin: `0 ${theme.spacing.spacing4}`,
  },
  attentionIcon: {
    position: "absolute",
    top: `calc(50% - ${theme.spacing.spacing7})`,
    right: `calc(50% - ${theme.spacing.spacing7})`,
  },
  iframeClassName: {
    borderRadius: theme.borders.borderRadius.lg,
    width: theme.width.full,
  },
  content: {
    fontSize: theme.typography.size.xs,
    fontWeight: theme.typography.fontWeightRegular,
    whiteSpace: "pre-line",
    paddingBottom: theme.spacing.spacing10,
  },
});
